import { Component, OnInit } from '@angular/core';
import { SystemSelectService } from '../../system-select/system-select.service';
import { BaseGridTemplate } from '../../../../shared/cgp-grid/base-cgp-grid.template';
import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Subject } from 'rxjs';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from 'rxjs';
import { SystemTimingControLDate } from '../../../../shared/domain/camtl/SystemTimingControlDate';
import {
  CamtlBaseService,
  DateTemplateService,
  DateTemplateSystemPhaseService,
  FunctionalViewService,
  SystemPhaseService,
  SystemTimingControlDatesService,
} from '../../camtl.service';
import { parseDate } from '@progress/kendo-angular-intl';


@Component({
  selector: 'functional-view',
  templateUrl: './functional-view.component.html',
})
export class FunctionalViewComponent extends BaseGridTemplate implements OnInit {
  system: any;
  functionalViewFilter: any[];
  selectedFunctionalView: any;
  functionalView: any[];
  selectedView: any;
  gridFilter: boolean = false;
  customFormDialogTemplate: Subject<any> = new BehaviorSubject<any>(undefined);
  customTemplate: any;

  constructor(
    private formBuilder: FormBuilder,
    private camtlBaseService: CamtlBaseService,
    private systemSelectService: SystemSelectService,
    private dateTemplateService: DateTemplateService,
    private dateTemplateSystemPhaseService: DateTemplateSystemPhaseService,
    public functionalViewService: FunctionalViewService,
    private systemPhaseService: SystemPhaseService,
    private systemTimingControlDatesService: SystemTimingControlDatesService,
  ) {
    super();
  }

  ngOnInit() {
    this.systemSelectService.system$
      .subscribe(sys => {
        if (this.system && this.system === sys) return;
        this.system = sys;
        this.updateView();
      });

    this.customFormDialogTemplate.subscribe(template => this.customTemplate = template);
    this.systemSelectService.get();

    Promise.all([
      this.functionalViewService.read(),
      this.dateTemplateService.read(),
      this.systemPhaseService.read()
    ]).then(x => this.updateView());
  }


  updateView() {
    if (this.system) {
      this.functionalViewFilter = this.functionalViewService.data
        .filter(item => item.DateTemplateId === this.system.DateTemplateId);
      this.handleValueChange(this.functionalViewFilter[0]);

      this.dateTemplateSystemPhaseService
        .read('/' + this.system.DateTemplateId + '/systemphases', true)
    } else {
      this.handleValueChange();
    }
  }

  toggleGridFilter() {
    this.gridFilter = !this.gridFilter;
  }


  handleValueChange(dataItem: any = undefined) {
    this.selectedFunctionalView = dataItem;
    if (dataItem) this.template.fileName = "FunctionalView - " + this.selectedFunctionalView.Name + ".xlsx";
    this.toggleGridFilter();
    this.selectedView = this.functionalViewFilter ? this.functionalViewFilter[0] : undefined;
  }


  handleFilter(value: any) {
    try {
      this.functionalViewFilter = this.functionalView
        .filter(item => {
          return item.Name.toLowerCase().indexOf(value.toLowerCase()) !== -1;
        })
    } catch (e) { }
  }


  handleRead = (): Promise<any> => {
    return this.selectedFunctionalView ?
      this.systemTimingControlDatesService
        .read(
          '/DateTemplate/datetemplateid/' + this.system.DateTemplateId +
          '/functionalviewid/' + this.selectedFunctionalView.Id +
          '/systemid/' + this.system.Id
          , true) :
      Promise.resolve([]);
  }


  handleControlDisabled = (controlName: string) => {
    let isDisabled: boolean = false;
    switch (controlName) {
      case 'excel':
      case 'zeroDateTemplate':
        isDisabled = this.selectedFunctionalView === undefined;
        break;
      default:
        break;
    }
    return isDisabled;
  }


  dateToString(date: Date): string {
    try {
      return date.toISOString();
    } catch (e) {
      return undefined;
    }
  } stringToDate(date: string): Date {
    return date ? parseDate(date) : new Date();
  }


  private formatDataItemDates(dataItem) {
    for (var key in dataItem) {
      if (dataItem.hasOwnProperty(key) && !key.includes('Id')) {
        try {
          dataItem[key] = this.stringToDate(dataItem[key]);
        } catch (e) { }
      }
    }
  }


  handleGridEdit = (dataItem, isDetailRow) => {
    this.formatDataItemDates(dataItem);

    let systemPhaseDateTemplate = this.dateTemplateSystemPhaseService.value
      .find(item => item.SystemPhaseId === dataItem.SystemPhaseId);

    if (!systemPhaseDateTemplate) return;

    let isDeactivated = systemPhaseDateTemplate.Status,
      isActualNotEditable = systemPhaseDateTemplate.IsActualEditable;

    // 1 1 1 : 0, 0
    // 0 1 0 : 0, 1
    // 1 1 0 : 0, 1
    // 1 1 1 : 1, 0
    // 1 1 0 : 1, 1
    this.editForm.get('NegotiatedDateMin').enable();
    this.editForm.get('NegotiatedDateMax').enable();
    this.editForm.get('PromisedDateMin').enable();
    this.editForm.get('PromisedDateMax').enable();
    this.editForm.get('ActualDateMin').enable();
    this.editForm.get('ActualDateMax').enable();


    if (isDeactivated) {
      this.editForm.get('NegotiatedDateMin').disable();
      this.editForm.get('NegotiatedDateMax').disable();
    }
    if (isActualNotEditable) {
      this.editForm.get('ActualDateMin').disable();
      this.editForm.get('ActualDateMax').disable();
    }

  }


  resetForm() {
    this.customFormDialogTemplate.next(undefined);
  }


  customSaveHandler(dataItem: any) {
    let systemId = 'systemId=' + this.system.Id + '&',
      dateTemplateId = systemId + 'dateTemplateId=' + this.system.DateTemplateId + '&',
      templateZeroDate = dateTemplateId + 'templateZeroDate=' + this.dateToString(dataItem.ZeroDate),
      urlExtension = '/GenerateDates/SystemTimingControlDates?' + templateZeroDate;
    this.camtlBaseService.save([], true, urlExtension, false, true, false)
      .then(response => this.toggleGridFilter());

    this.resetForm();
  }


  customCancelHandler() {
    this.resetForm();
  }


  getEditForm() {
    return this.formBuilder.group({
      Id: [],
      DateTemplateId: ['', Validators.required],
      SystemId: ['', Validators.required],
      SystemPhaseId: ['', Validators.required],
      TemplateDate: ['', Validators.required],

      NegotiatedDateMin: ['', Validators.required],
      NegotiatedDateMax: ['', Validators.required],

      PromisedDateMin: ['', Validators.required],
      PromisedDateMax: ['', Validators.required],

      ActualDateMin: ['', Validators.required],
      ActualDateMax: ['', Validators.required],
    })
  }

  /****************************************************************************
   * Date Template
   ***************************************************************************/
  handleZeroDate = () => {
    let editForm: FormGroup = new FormGroup({
      ZeroDate: new FormControl('', Validators.required),
    });

    let dataItem: any = { ZeroDate: new Date() };

    editForm.reset(dataItem);

    let template = {
      title: this.zeroDateFormDialog.title,
      editForm: editForm,
      formControls: this.zeroDateFormDialog.formControls,
    }
    this.customFormDialogTemplate.next(template);
  }


  zeroDateFormDialog = {
    title: "Template Dates",
    formControls: [{
      type: "date",
      name: "ZeroDate",
      title: "Zero Date",
    }]
  }

  zeroDateControl = {
    id: "zeroDateTemplate",
    iconClass: "fa fa-calendar-o",
    title: "Generate Template Dates",
    text: "Generate Template Dates",
    callback: this.handleZeroDate,
  }

  columns = [
    {
      title: "System Phase",
      field: "SystemPhaseDescription"
    },
    {
      title: "Template Date",
      field: "TemplateDate",
      width: 285,
      template: {
        type: 'date',
        dateFormat: 'shortDate'
      }
    },
    // {
    //   title: 'Negotiated Date Range',
    //   columns: [
    //     {
    //       field: 'NegotiatedDateMin',
    //       title: 'Min Date',
    //       template: {
    //         type: 'date',
    //         dateFormat: 'shortDate'
    //       }
    //     },
    //     {
    //       field: 'NegotiatedDateMax',
    //       title: 'Max Date',
    //       template: {
    //         type: 'date',
    //         dateFormat: 'shortDate'
    //       }
    //     },
    //   ]
    // },
    // {
    //   title: 'Promise Date Range',
    //   columns: [
    //     {
    //       field: 'PromisedDateMin',
    //       title: 'Min Date',
    //       template: {
    //         type: 'date',
    //         dateFormat: 'shortDate'
    //       }
    //     },
    //     {
    //       field: 'PromisedDateMax',
    //       title: 'Max Date',
    //       template: {
    //         type: 'date',
    //         dateFormat: 'shortDate'
    //       }
    //     },
    //   ]
    // },
    // {
    //   title: 'Actual Date Range',
    //   columns: [
    //     {
    //       field: 'ActualDateMin',
    //       title: 'Min Date',
    //       template: {
    //         type: 'date',
    //         dateFormat: 'shortDate'
    //       }
    //     },
    //     {
    //       field: 'ActualDateMax',
    //       title: 'Max Date',
    //       template: {
    //         type: 'date',
    //         dateFormat: 'shortDate'
    //       }
    //     },
    //   ]
    // }
  ]


  template = {
    title: "System Phase",
    controls: {
      add: false,
      edit: false,
      delete: false,
      excel: true,
      width: 1,
      customToolbar: [
        this.zeroDateControl,
      ],
      isDisabled: this.handleControlDisabled,
    },
    columns: this.columns,
    service: this.systemTimingControlDatesService,
    read: this.handleRead,
    edit: this.handleGridEdit,
    fileName: "functional_view.xlsx"
  }


  editForm = this.getEditForm();



  formDialog = {
    title: "Timing Chart System Phase",
    formControls: [
      {
        type: 'date',
        name: 'ActualDateMin',
        title: 'Actual Date Minimum',
      }, {
        type: 'date',
        name: 'ActualDateMax',
        title: 'Actual Date Maximum',
      }, {
        type: 'date',
        name: 'NegotiatedDateMin',
        title: 'Negotiated Date Minimum',
      }, {
        type: 'date',
        name: 'NegotiatedDateMax',
        title: 'Negotiated Date Maximum',
      }, {
        type: 'date',
        name: 'PromisedDateMin',
        title: 'Promised Date Minimum',
      }, {
        type: 'date',
        name: 'PromisedDateMax',
        title: 'Promised Date Maximum',
      }],
  }


}
